module.exports = __webpack_public_path__ + "img/tool-news.397ea68c.svg";